var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsvp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26562 12.3574C7.00195 12.6504 6.5625 12.6504 6.29883 12.3574L4.42383 10.4824C4.13086 10.2188 4.13086 9.7793 4.42383 9.48633C4.6875 9.22266 5.12695 9.22266 5.39062 9.48633L6.79688 10.8926L9.58008 8.08008C9.84375 7.81641 10.2832 7.81641 10.5469 8.08008C10.8398 8.37305 10.8398 8.8125 10.5469 9.07617L7.26562 12.3574ZM4.6875 0.375C5.06836 0.375 5.39062 0.697266 5.39062 1.07812V2.25H9.60938V1.07812C9.60938 0.697266 9.90234 0.375 10.3125 0.375C10.6934 0.375 11.0156 0.697266 11.0156 1.07812V2.25H12.1875C13.2129 2.25 14.0625 3.09961 14.0625 4.125V13.5C14.0625 14.5547 13.2129 15.375 12.1875 15.375H2.8125C1.75781 15.375 0.9375 14.5547 0.9375 13.5V4.125C0.9375 3.09961 1.75781 2.25 2.8125 2.25H3.98438V1.07812C3.98438 0.697266 4.27734 0.375 4.6875 0.375ZM12.6562 6H2.34375V13.5C2.34375 13.7637 2.54883 13.9688 2.8125 13.9688H12.1875C12.4219 13.9688 12.6562 13.7637 12.6562 13.5V6Z",
    fill: "#030303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsvp);
export default __webpack_public_path__ + "static/media/rsvp.738e5dafbe26aca861f13c3df0465b39.svg";
export { ForwardRef as ReactComponent };